export interface ContasPagarCreateRequest {
    // Cabeçalho do documento
    idPessoaFornecedor: number;
    dataEmissao: string;
    dataCompetencia: string;
    valorTotal: number;
    descricaoOriginal: string;
    numeroDocumento?: string;
    idCategoriaFinanceira: number;

    // Centro de custo (direto, sem rateio)
    idCentroCusto?: number | null;

    // Rateio
    hasRateio: boolean;
    rateios?: RateioItemRequest[] | null;

    // Recorrência
    isRecorrente: boolean;
    recorrencia?: RecorrenciaRequest | null;

    // Parcelamento (quando não recorrente)
    parcelamento?: ParcelamentoRequest | null;

    // Tags (tags)
    tags?: number[] | null;

    // Dados complementares por parcela (usados apenas quando À vista / 1x)
    observacoesHtml?: string | null;
    codigoBarrasLinhaDigitavel?: string | null;
    chavePix?: string | null;
}

export interface RateioItemRequest {
    idCentroCusto: number;
    valor?: number | null;
    percentual?: number | null;
}

export interface RecorrenciaRequest {
    intervalo: number;
    idFrequenciaRecorrencia: number;
    diaVencimentoFixo: number;
    quantidadeVezes: number;
    idFormaPagamento?: number | null;
    idContaFinanceira?: number | null;
    dataInicio: string;
    descricaoBase?: string | null;
}

export interface ParcelamentoRequest {
    idTipoParcelamento: number;
    dataVencimento?: string | null;
    intervaloDiasParcelas?: number | null;
    idFormaPagamento?: number | null;
    idContaFinanceira?: number | null;
    isPago: boolean;
    parcelas?: ParcelaItemRequest[] | null;
}

export interface ParcelaItemRequest {
    nroParcela: number;
    dataVencimento: string;
    valor: number;
    idFormaPagamento?: number | null;
    idContaFinanceira?: number | null;
    descricao?: string | null;
}

export interface ContasPagarUpdateRequest {
    // Identificação
    idContasPagar: number;
    idContasPagarParcela?: number | null;

    // Tipo de edição para recorrência:
    // 1 = Apenas este lançamento
    // 2 = Lançamento atual e todos os não vencidos sem baixas
    // 3 = Lançamento atual e todos os em aberto (vencidos + a vencer) sem baixas
    // 4 = Todos os lançamentos
    tipoEdicaoRecorrencia?: number | null;

    // Cabeçalho do documento
    idPessoaFornecedor: number;
    dataEmissao: string;
    dataCompetencia: string;
    valorTotal: number;
    descricaoOriginal: string;
    numeroDocumento?: string | null;
    idCategoriaFinanceira: number;

    // Centro de custo
    idCentroCusto?: number | null;

    // Rateio
    hasRateio: boolean;
    rateios?: RateioItemRequest[] | null;

    // Tags
    tags?: number[] | null;

    // Dados da parcela em edição
    dataVencimento?: string | null;
    datetimePrevisao?: string | null;
    valorParcela?: number | null;
    idFormaPagamento?: number | null;
    idContaFinanceira?: number | null;
    valorJurosPrevisto?: number | null;
    valorMultaPrevisto?: number | null;
    valorDescontoPrevisto?: number | null;
    descricaoParcela?: string | null;
    isPago: boolean;

    // Dados complementares
    observacoesHtml?: string | null;
    codigoBarrasLinhaDigitavel?: string | null;
    chavePix?: string | null;
}

export interface ContasPagarParcelaAnexoRequest {
    base64: string;
    nomeArquivo: string;
}

export interface ContasPagarBulkEditRequest {
    idsContasPagarParcela: number[];
    idFornecedor?: number | null;
    dataCompetencia?: string | null;
    idCategoriaFinanceira?: number | null;
    idCentroCusto?: number | null;
    descricao?: string | null;
    observacaoHtml?: string | null;
    idContaFinanceira?: number | null;
    anexos?: ContasPagarParcelaAnexoRequest[] | null;
}

export interface ContasPagarBulkCategoriaRequest {
    idsContasPagarParcela: number[];
    idCategoriaFinanceira: number;
}

export enum AcaoTagsEnum {
    Incluir = 1,
    Remover = 2
}

export interface ContasPagarBulkTagsRequest {
    idsContasPagarParcela: number[];
    acao: AcaoTagsEnum;
    idsTags: number[];
}
